import * as Sentry from "@sentry/react";

const SENTRY_DSN = "https://17b7973d69ed950920d2e828c1d53bb3@o4511152176037888.ingest.de.sentry.io/4511152512106576";

let initialised = false;

export function initSentry() {
  if (initialised || typeof window === "undefined") return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.DEV ? "development" : "production",
    enabled: !import.meta.env.DEV, // Only capture in production
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true, // Mask all text for privacy
        blockAllMedia: true, // Block media for privacy
      }),
    ],
    tracesSampleRate: 0.1, // 10% of transactions for performance
    replaysSessionSampleRate: 0, // Don't record sessions
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      // Strip any PII that might leak into error payloads
      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }
      // Strip sensitive breadcrumb data
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map((bc) => {
          if (bc.category === "xhr" || bc.category === "fetch") {
            delete bc.data?.requestBody;
            delete bc.data?.responseBody;
          }
          return bc;
        });
      }
      return event;
    },
  });

  initialised = true;
}

/**
 * Set user context — NO PII, only internal IDs and role.
 */
export function setSentryUser(
  userOrId: string | { id: string; email?: string | null; workspaceId?: string | null },
  properties?: { role?: string; workspaceId?: string },
) {
  if (typeof userOrId === "string") {
    Sentry.setUser({
      id: userOrId,
      role: properties?.role,
      workspace_id: properties?.workspaceId,
    } as any);
    return;
  }
  Sentry.setUser({
    id: userOrId.id,
    workspace_id: userOrId.workspaceId,
  } as any);
}

/** Clear user context on logout */
export function clearSentryUser() {
  Sentry.setUser(null);
}

/** Manually capture an error */
export function captureError(error: Error, context?: Record<string, unknown>) {
  Sentry.captureException(error, { extra: context });
}

export { Sentry };
